module.exports = __webpack_public_path__ + "img/logo.99f4fae5.png";